import React, { useEffect, useState } from "react";
import './style.css';
import { Menu, List, Col, Avatar } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory } from "react-router-dom";
import { SyncOutlined } from "@ant-design/icons";
import { getNotificationList, ViewNotificationSelector, takeActionAsyn, clickReadableUserAsyn, takeActionChildProcessAsyn, clearState } from './ViewNotificationSlice';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { authSelector } from '../Auth/authSlice';
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;



export default function ViewNotification({ sendDataToParent }) {

    const dispatch = useDispatch();
    let history = useHistory();
    const [isLoading, setLoading] = React.useState(false);
    const [isToast, setToast] = React.useState(false);
    const [notifyRecord, setnotifyRecord] = useState([]);

    const { isFetching, isNotifySuccess, isError, errorMessage, NotificationData, notifyCount, imagePath } = useSelector(
        ViewNotificationSelector
    );

    const { isLoggedIn, isGoogleSignIn, user } = useSelector(
        authSelector
    );

    useEffect(() => {
        setLoading(true);
        setToast(false);
        dispatch(clearState());
        dispatch(getNotificationList());
    }, []);

    useEffect(() => {

        if (isError) {
            setnotifyRecord([]);
            setLoading(false);
            setToast(true);
            toast.error(errorMessage);
            dispatch(clearState());
        }
        if (isNotifySuccess) {
            setLoading(false);
            setnotifyRecord(NotificationData);
            sendDataToParent(notifyCount);
        }

    }, [isError, isNotifySuccess, setLoading, NotificationData, notifyCount, imagePath]);


    const data = [
        {
            id: 1,
            image: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png',
            name: 'Mr John Doe',
            msg: 'Ant Design, a design language for background applications, is refined by Ant UED Team',
        }
    ];


    const onNotificationClick = (e, value) => {
        e.preventDefault();
        // console.log("childProcess", value);
        let data = {
            "notificationId": value.id,
        }
        dispatch(clickReadableUserAsyn(data));

        if (value.processId) {

            if (value.checkchildprocess === true) {

                let takeActionChildProcess = dispatch(takeActionChildProcessAsyn(value.processId)).then((res) => {

                    user.userType === "CHD" ?

                        history.push({
                            pathname: '/verify-document2',
                            state: { documentInfo: res.data, processId: res.data.documentUpdatedData.processId, viewDocument: true, }
                        })

                        :
                        history.push({
                            pathname: '/verify-document2',
                            state: { documentInfo: res.data, processId: res.data.documentUpdatedData.processId, viewDocument: true }
                        });

                });
            }
            else {

                let takeAction = dispatch(takeActionAsyn(value.processId)).then((res) => {

                    user.userType === "CHD" ?

                        history.push({
                            pathname: '/verify-document2',
                            // search: '?query=abc',
                            state: { documentInfo: res.data, processId: res.data.documentUpdatedData.processId, viewDocument: true, }
                        })

                        :
                        history.push({
                            pathname: '/verify-document2',
                            // search: '?query=abc',
                            state: { documentInfo: res.data, processId: res.data.documentUpdatedData.processId, viewDocument: true, }
                        });

                });

            }

        }
    }


    let dataSource = isLoading
        ? []
        : notifyRecord && notifyRecord.length > 0 ? notifyRecord.map(row => ({
            id: row.uuid,
            image: row && row.userDetail && row.userDetail.profilePic ? imagePath + row.userDetail.profilePic : './default-View-SubAdmin-Img.png',
            name: row.userDetail.fullName,
            msg: row.message,
            processId: row.documentDetail && row.documentDetail.processId,
            checkchildprocess: row.childProcess,
        })) : [];

    return (
        <>
            <Menu.Item className="noti-dropdown-item">
                <span className="notifiaction-count">Notification ({notifyCount ? notifyCount : 0})</span>
                <Link to="/view-all-notification">View All</Link>
            </Menu.Item>
            <List
                className="noti-dropdown-item"
                itemLayout="horizontal"
                dataSource={dataSource}
                renderItem={item => (
                    <List.Item style={{ cursor: "pointer" }} onClick={(e) => onNotificationClick(e, item)}>
                        <List.Item.Meta
                            avatar={<Avatar src={item.image} />}
                            title={<span className="name">{item.name}</span>}
                            description={<span className="notice-text">{item.msg}</span>}
                        />
                    </List.Item>
                )}
            />
        </>
    );
}
